import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Assessment List")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-md-1 mt-2 px-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_28 = { class: "flex-grow-1" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "fs-6 text-gray-600" }
const _hoisted_31 = { class: "mt-10" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = {
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = {
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = {
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Assessment List", -1)
const _hoisted_40 = { class: "card mb-5 mb-xl-10" }
const _hoisted_41 = {
  class: "card-body border-top p-3",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_42 = { class: "row mt-1 w-100 m-0" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, null, -1)
const _hoisted_44 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_52 = { class: "collapse show" }
const _hoisted_53 = { class: "card-body border-top p-6" }
const _hoisted_54 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 0,
  class: "text-success"
}
const _hoisted_58 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_59 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_60 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_61 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_62 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_63 = {
  key: 0,
  class: "text-success"
}
const _hoisted_64 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_65 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_66 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_67 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_68 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.trainee.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Partner",
                  modelValue: _ctx.trainee.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                  filterable: "",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trainingInstitute())),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: assoc.id,
                        label: assoc.entity_short_name,
                        value: assoc.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Institute",
                  modelValue: _ctx.trainee.training_institute_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCourseList()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: inst.id,
                        label: inst.institute_name,
                        value: inst.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(inst.institute_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Course",
                  modelValue: _ctx.trainee.course_info_id,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getBatchList()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: course.id,
                        label: course.course_name,
                        value: course.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(course.course_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Batch",
                  modelValue: _ctx.trainee.batch_info_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainee.batch_info_id) = $event)),
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getAssessmentEligibleTerm())),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: batch.id,
                        label: batch.batch_sequence_number,
                        value: batch.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(batch.batch_sequence_number), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.termList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Term",
                      modelValue: _ctx.trainee.term_no,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.trainee.term_no) = $event)),
                      name: "batch_id",
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.termList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.term_no,
                            label: info.term_no,
                            value: info.term_no
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.term_no), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkAssessmentEligiblity())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_26
                ])
              ])
            ]),
            (_ctx.showAssessmentList == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, " Total : " + _toDisplayString(_ctx.assessmentCount?.total_trainee) + ", Female: " + _toDisplayString(_ctx.assessmentCount?.total_trainee_female), 1)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, " Assessed: " + _toDisplayString(_ctx.assessmentCount?.total_assessed) + " (Competent : " + _toDisplayString(_ctx.assessmentCount?.total_competent) + ", Not Competent : " + _toDisplayString(_ctx.assessmentCount?.total_not_competent) + ") ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, " Absent : " + _toDisplayString(_ctx.assessmentCount?.total_absent) + ", Dropout : " + _toDisplayString(_ctx.assessmentCount?.total_dropout), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAssessmentList == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_46),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_48),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_50)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.assessmentList,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-photo": _withCtx(({ row: assesment }) => [
                                (this.trainee.term_no && this.trainee.term_no != this.termList.length)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: 
                                _ctx.api_url + assesment?.file_path
                              ,
                                      alt: "",
                                      width: "32",
                                      height: "32"
                                    }, null, 8, _hoisted_55))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: 
                                _ctx.api_url + assesment?.attach_file_info?.file_path
                              ,
                                      alt: "",
                                      width: "32",
                                      height: "32"
                                    }, null, 8, _hoisted_56))
                              ]),
                              "cell-ref_no": _withCtx(({ row: assesment }) => [
                                _createTextVNode(_toDisplayString(assesment?.reference_number), 1)
                              ]),
                              "cell-reg_no": _withCtx(({ row: assesment }) => [
                                _createTextVNode(_toDisplayString(assesment?.registration_number), 1)
                              ]),
                              "cell-name": _withCtx(({ row: assesment }) => [
                                _createTextVNode(_toDisplayString(assesment?.trainee_name), 1)
                              ]),
                              "cell-mobile": _withCtx(({ row: assesment }) => [
                                _createTextVNode(_toDisplayString(assesment?.mobile), 1)
                              ]),
                              "cell-assessment_date": _withCtx(({ row: assesment }) => [
                                (this.trainee.term_no && this.trainee.term_no != this.termList.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(assesment?.assessment_date
                                  ? _ctx.moment(
                                      assesment?.assessment_date
                                    ).format('DD-MM-YYYY')
                                  : assesment?.assessment_date), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(assesment?.training_assessment?.assessment_date ? _ctx.moment(assesment?.training_assessment?.assessment_date).format('DD-MM-YYYY')
                                  : assesment?.training_assessment?.assessment_date), 1)
                                    ], 64))
                              ]),
                              "cell-reassessment_date": _withCtx(({ row: assesment }) => [
                                _createTextVNode(_toDisplayString(assesment?.training_assessment?.reassessment_date
                                ? _ctx.moment(
                                    assesment?.training_assessment
                                      ?.reassessment_date
                                  ).format('DD-MM-YYYY')
                                : assesment?.training_assessment
                                    ?.reassessment_date), 1)
                              ]),
                              "cell-assessor": _withCtx(({ row: assesment }) => [
                                (this.trainee.term_no && this.trainee.term_no != this.termList.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(assesment?.assessor_name), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(assesment?.training_assessment?.assessor?.employee_info?.name), 1)
                                    ], 64))
                              ]),
                              "cell-assessment_result": _withCtx(({ row: assesment }) => [
                                (this.trainee.term_no && this.trainee.term_no != this.termList.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (assesment?.assessment_score)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (assesment?.assessment_score == 100)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Competent"))
                                              : ( assesment?.assessment_score == 50)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Not Competent"))
                                                : (assesment?.assessment_score == 0)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Absent"))
                                                  : (assesment?.assessment_score == -1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Dropout"))
                                                    : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (assesment.attendance_percentage < assesment?.dropout_below_perc)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Dropout"))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_62, "Not Assessed Yet"))
                                          ], 64))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (assesment.training_assessment?.assessment_score)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (assesment?.training_assessment?.assessment_score == 100)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Competent"))
                                              : (assesment?.training_assessment?.assessment_score == 50)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Not Competent"))
                                                : (assesment?.assessment_score == 0)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Absent"))
                                                  : (assesment?.assessment_score == -1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Dropout"))
                                                    : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (assesment.attendance_percentage < assesment?.batch_info?.dropout_below_perc)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_67, "Dropout"))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_68, "Not Assessed Yet"))
                                          ], 64))
                                    ], 64))
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}